(function () {
  document.querySelectorAll('[data-tw-copy-code]').forEach(function (button) {
    var code = button.getAttribute('data-tw-copy-code');
    var label = button.querySelector('[data-tw-copy-code-label]');
    if (!label) {
      return;
    }
    var originalText = label.textContent;
    var resetTimer = null;

    button.addEventListener('click', function () {
      var showCopied = function () {
        label.textContent = 'Copied';
        button.classList.add('is-copied');
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          label.textContent = originalText;
          button.classList.remove('is-copied');
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied, function () {
          /* Clipboard permission denied or unavailable — the code is
             still visible as plain text, so the customer can select and
             copy it manually. No further fallback needed. */
        });
      }
    });
  });
})();
